import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mall',
  templateUrl: './mall.component.html',
  styleUrls: ['./mall.component.scss']
})
export class MallComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
